export const checkpointsFr = {
    actions: {
        eraseDetections:
            'Réinitialiser les détections supprimera toutes les détections actuellement enregistrées. Êtes-vous sûr(e) ?',
        eraseDetectionsTitle: 'Réinitialiser les détections',

        reassignDevice:
            "Souhaitez-vous réassigner l'appareil {device} au checkpoint {checkpoint} ?",
        reassignDeviceTitle: 'Réassigner un appareil'
    },
    api: {
        error: {
            createCheckpoint: 'Erreur lors de la création du checkpoint {name}',
            deleteCheckpoint: 'Erreur lors de la suppression du checkpoint {name}',
            fetchCheckpoint: 'Erreur lors de la récupération du checkpoint',
            fetchCheckpoints: 'Erreur lors de la récupération des checkpoints',
            updateCheckpoint: 'Erreur lors de la modification du checkpoint {name}'
        },
        success: {
            createCheckpoint: 'Création du checkpoint {name} effectuée avec succès !',
            deleteCheckpoint: 'Suppression du checkpoint {name} effectuée avec succès !',
            fetchCheckpoint: 'Récupération du checkpoint effectuée avec succès !',
            fetchCheckpoints: 'Récupération des checkpoints effectuée avec succès !',
            updateCheckpoint: 'Modification(s) du checkpoint {name} effectuée(s) avec succès !'
        }
    },
    buttons: {
        forceAssociate: "Forcer l'association",
        showAll: 'Montrer tous les checkpoints',
        hideAll: 'Cacher les checkpoints supplémentaires'
    },

    model: {
        associates: 'Appareils associés',
        comments: 'Commentaire',
        name: 'Nom du checkpoint',
        id: 'Checkpoint ID Hub'
    },
    detail: {
        alreadyAssociatedCheckpoints:
            "Cet appareil est déjà associé à un ou plusieurs checkpoints, confirmer l'association à ce nouveau checkpoint le dissociera de tous les checkpoints suivants :",
        associates: 'Associer un appareil',
        associateDevice: "Associer l'appareil",
        noDeviceAssociated: 'Aucun appareil associé',
        dissociateDevice: "Dissocier l'appareil"
    },
    partner: {
        livetrailCheckpointId: 'ID Livetrail'
    },
    title: {
        associateDeviceTitle: 'Associer des appareils',
        informationsTitle: 'Informations',
        partnerTitle: 'Informations du partenaire',
        actionsTitle: 'Actions'
    }
}
